import React from "react";
import { Outlet } from "react-router-dom";
import { SidebarProvider } from "../../components/ui/sidebar";
import AdminHeader from "./AdminHeader";
import { useLanguage } from "../../context/LanguageContext";
import { AppSidebarAdmin } from "../../components/appSidebarAdmin";
import Footer from "../../components/Footer";

export default function AdminRoot() {
  const { language } = useLanguage();

  return (
    <SidebarProvider>
      {language !== "ar" && <AppSidebarAdmin />}
      <main className="w-full flex flex-col">
        <AdminHeader />
        <div className="p-5 flex-1">
          <Outlet />
        </div>
        <Footer />
      </main>
      {language === "ar" && <AppSidebarAdmin />}
    </SidebarProvider>
  );
}
